const comments = [
  {
    name: '影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20man%20with%20warm%20friendly%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20natural%20look&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    text: '用了色影视快一年了，资源真的全！新上映的电影基本隔天就有高清版，播放也很流畅，从来没卡过。强烈推荐给喜欢追剧的朋友们！',
    time: '2小时前',
    tag: '忠实用户',
  },
  {
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Asian%20woman%20with%20cute%20smile%2C%20casual%20outfit%2C%20soft%20warm%20lighting%2C%20cream%20background%2C%20natural%20beauty%20portrait&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    text: '不用注册就能看，这点太良心了！画质清晰，更新速度也快，国产剧韩剧日剧啥都有，已经安利给周围所有人了，春色影视最新网址我一直收藏着。',
    time: '5小时前',
    tag: '活跃用户',
  },
  {
    name: '电影发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Asian%20man%20with%20glasses%20and%20warm%20thoughtful%20expression%2C%20casual%20shirt%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20professional%20look&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    text: '作为一个阅片量过千的老影迷，色影视的片源质量真的没得说。多线路切换功能特别实用，高峰期也能流畅播放，而且分类做得很好，找片特别方便。',
    time: '1天前',
    tag: '资深影迷',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          用户口碑
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">真实用户的观影体验</p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {comment.tag}
                  </span>
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">
                "{comment.text}"
              </p>
              <div className="mt-4 flex items-center gap-1 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <span className="ml-2 text-xs text-foreground-400">{comment.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}